function CompareToDirective() {
  return {
    restrict: 'E',
    replace: true,
    scope: {
      buyerData: '=',
      venue: '='
    },
    template: `
    <div class="buyer-total">
      <div class="header-row">
        Buyer Total
      </div>
      <!-- PRICE -->
      <div class="item-row row">
        <div class="col-xs-6 item-label">
          <span ng-if="buyerData.paymentType !== 'ADVANCE_DEPOSIT'">Subtotal</span>
          <span ng-if="buyerData.paymentType === 'ADVANCE_DEPOSIT'">Deposit</span>
        </div>
        <div class="col-xs-6 item-value">
          {{ buyerData.price || 0 | venueCurrency : venue.currencyCode : venue.languageCode }}
        </div>
      </div>
      <!-- TAX -->
      <div class="item-row row">
        <div class="col-xs-6 item-label">
          Tax <span>{{ buyerData.taxPercent | percentage }}</span>
        </div>
        <div class="col-xs-6 item-value">
          {{ buyerData.tax || 0 | venueCurrency : venue.currencyCode : venue.languageCode }}
        </div>
      </div>
      <!-- TIP -->
      <div class="item-row row">
        <div class="col-xs-6 item-label">
          Service Charge <span>{{ buyerData.tipPercent | percentage }}</span>
        </div>
        <div class="col-xs-6 item-value">
          {{ buyerData.tip || 0 | venueCurrency : venue.currencyCode : venue.languageCode }}
        </div>
      </div>
      <!-- FEES -->
      <div class="item-row row" ng-repeat="fee in buyerData.fees">
        <div class="col-xs-6 item-label">
          <span ng-if="fee.type === 'PERCENT' || fee.feeType === 'PROCESSING'">
            {{ fee.name }} <span>{{fee.amount | percentage}}</span>
          </span>
          <span ng-if="fee.type === 'FLAT'">
            {{ fee.name }} <span>{{ fee.amount }}</span>
          </span>
        </div>
        <div class="col-xs-6 item-value">
          {{ fee.value || 0 | venueCurrency : venue.currencyCode : venue.languageCode }}
        </div>
      </div>
      <!-- TOTAL -->
      <div class="item-row row total-row">
        <div class="col-xs-6 item-label">
          Total
        </div>
        <div class="col-xs-6 item-value">
          {{ buyerData.total || 0 | venueCurrency : venue.currencyCode : venue.languageCode }}
        </div>
      </div>
      <!-- DUE ON ARRIVAL -->
      <div class="item-row row" ng-if="buyerData.paymentType === 'ADVANCE_DEPOSIT' || buyerData.paymentType === 'VENUE' || buyerData.paymentType === 'NONE'">
        <div class="col-xs-6 item-label">
          Estimated due at the venue
        </div>
        <div class="col-xs-6 item-value">
          {{ buyerData.dueOnArrival || 0 | venueCurrency : venue.currencyCode : venue.languageCode }}
        </div>
      </div>
    </div>
    `
  };
}

CompareToDirective.$inject = [];

export default CompareToDirective;



// WEBPACK FOOTER //
// ./src/directives/buyerTotal.js